import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5137a03e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rd-header" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "rd-wrapper rd-header-wraper" }
const _hoisted_4 = { class: "rd-l" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "rd-r rd-header-image-wrapper" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "rd-wrapper rd-content" }
const _hoisted_9 = {
  key: 0,
  class: "rd-l"
}
const _hoisted_10 = {
  key: 0,
  class: "rd-token-wrapper"
}
const _hoisted_11 = {
  key: 1,
  class: "rd-to"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "rd-to" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = {
  key: 2,
  class: "rd-to"
}
const _hoisted_16 = ["textContent"]
const _hoisted_17 = {
  key: 3,
  class: "rd-to"
}
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = {
  key: 4,
  class: "rd-to"
}
const _hoisted_21 = ["textContent"]
const _hoisted_22 = ["textContent"]
const _hoisted_23 = {
  key: 5,
  class: "rd-to"
}
const _hoisted_24 = ["textContent"]
const _hoisted_25 = ["textContent"]
const _hoisted_26 = {
  key: 6,
  class: "rd-loc"
}
const _hoisted_27 = ["textContent"]
const _hoisted_28 = ["textContent"]
const _hoisted_29 = {
  key: 7,
  class: "rd-tnc"
}
const _hoisted_30 = ["textContent"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 8,
  class: "rd-tnc"
}
const _hoisted_33 = ["textContent"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 1,
  class: "rd-full"
}
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "rd-to" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rd-r" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberHeader = _resolveComponent("MemberHeader")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MemberHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "rd-back",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onBackClicked && $setup.onBackClicked(...args)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "arrow-right",
          "icon-name": "arrow-left"
        }),
        _createElementVNode("h4", {
          class: "fw6 text-uppercase",
          textContent: _toDisplayString(_ctx.$t('back-to-all'))
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", {
            class: "font-d fw6 rd-header-name",
            textContent: _toDisplayString($setup.detail?.Name ?? $setup.detail?.EventTitle ?? '')
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          ($props.category !== 'event')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "rd-img",
                src: $setup.detail?.ImageURL || $setup.detail?.BannerURL,
                alt: $setup.detail?.Name ?? ''
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      ($props.category !== 'event')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            ($setup.detail?.PointsToRedeem !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_SvgIcon, {
                    class: "token",
                    "icon-name": "token"
                  }),
                  _createElementVNode("div", null, "VIC Points: " + _toDisplayString($setup.detail?.PointsToRedeem?.toLocaleString()), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    innerHTML: $setup.detail?.Description
                  }, null, 8, _hoisted_12)
                ])),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", {
                class: "fw6",
                textContent: _toDisplayString($props.category.toLowerCase() === 'reward' ? _ctx.$t('redemption-period') : _ctx.$t('promotion-period') )
              }, null, 8, _hoisted_14),
              _createElementVNode("h4", null, _toDisplayString($setup.detail?.EffectiveFrom ?? $setup.detail?.From ?? $setup.detail?.StartDate ?? '') + " - " + _toDisplayString($setup.detail?.EffectiveTo ?? $setup.detail?.To ?? $setup.detail?.EndDate ?? ''), 1)
            ]),
            ($setup.detail?.StartDate !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('event-date'))
                  }, null, 8, _hoisted_16),
                  _createElementVNode("h4", null, _toDisplayString($setup.detail?.StartDate ?? '') + " - " + _toDisplayString($setup.detail?.EndDate ?? ''), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.detail?.Location !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('redemption-location'))
                  }, null, 8, _hoisted_18),
                  _createElementVNode("h4", {
                    textContent: _toDisplayString(_ctx.$t('shop') + ' ' + $setup.detail?.Location)
                  }, null, 8, _hoisted_19)
                ]))
              : _createCommentVNode("", true),
            ($setup.detail?.Venue !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('venue'))
                  }, null, 8, _hoisted_21),
                  _createElementVNode("h4", {
                    textContent: _toDisplayString($setup.detail?.Venue)
                  }, null, 8, _hoisted_22)
                ]))
              : _createCommentVNode("", true),
            (false && $setup.detail?.OpeningHours !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('opening-hour'))
                  }, null, 8, _hoisted_24),
                  _createElementVNode("h4", {
                    textContent: _toDisplayString($setup.detail?.OpeningHours)
                  }, null, 8, _hoisted_25)
                ]))
              : _createCommentVNode("", true),
            ($setup.detail?.Enquiry !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('enquiry'))
                  }, null, 8, _hoisted_27),
                  _createElementVNode("h4", {
                    textContent: _toDisplayString($setup.detail?.Enquiry)
                  }, null, 8, _hoisted_28)
                ]))
              : _createCommentVNode("", true),
            ($setup.detail?.TAC !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("h4", {
                    class: "fw6",
                    textContent: _toDisplayString(_ctx.$t('tnc'))
                  }, null, 8, _hoisted_30),
                  _createElementVNode("div", {
                    innerHTML: $setup.detail?.TAC
                  }, null, 8, _hoisted_31)
                ]))
              : ($setup.detail?.Remarks !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("h4", {
                      class: "fw6",
                      textContent: _toDisplayString(_ctx.$t('remarks'))
                    }, null, 8, _hoisted_33),
                    _createElementVNode("div", {
                      innerHTML: $setup.detail?.Remarks
                    }, null, 8, _hoisted_34)
                  ]))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("img", {
              class: "rd-event-img",
              src: $setup.detail?.ImageURL || $setup.detail?.BannerURL,
              alt: $setup.detail?.Name ?? ''
            }, null, 8, _hoisted_36),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h4", {
                class: "fw6",
                innerHTML: $setup.detail?.Description
              }, null, 8, _hoisted_38)
            ])
          ])),
      _hoisted_39
    ])
  ], 64))
}